var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalQuestions(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50837 11.9649C2.60793 12.2161 2.63009 12.4912 2.57202 12.7551L1.85092 14.9827C1.82769 15.0956 1.8337 15.2127 1.86838 15.3227C1.90306 15.4327 1.96526 15.532 2.04908 15.6112C2.13291 15.6904 2.23558 15.7469 2.34736 15.7753C2.45914 15.8037 2.57632 15.8031 2.6878 15.7735L4.99868 15.0978C5.24766 15.0484 5.5055 15.07 5.7428 15.1601C7.18863 15.8353 8.82648 15.9781 10.3674 15.5634C11.9083 15.1487 13.2532 14.2031 14.1648 12.8934C15.0765 11.5838 15.4963 9.9942 15.3501 8.40518C15.204 6.81617 14.5013 5.32982 13.3661 4.20838C12.2309 3.08695 10.7361 2.40249 9.1454 2.27578C7.55472 2.14907 5.97039 2.58825 4.67195 3.51582C3.37351 4.4434 2.44441 5.79976 2.04856 7.34561C1.65271 8.89145 1.81556 10.5274 2.50837 11.9649Z",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63672 6.99379C6.7959 6.54128 7.1101 6.1597 7.52367 5.91664C7.93723 5.67359 8.42347 5.58474 8.89627 5.66584C9.36906 5.74694 9.7979 5.99274 10.1068 6.35972C10.4157 6.72671 10.5848 7.19118 10.5841 7.67088C10.5841 9.02504 8.55286 9.70213 8.55286 9.70213M8.60742 12.4104H8.61419",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalQuestions);
export default __webpack_public_path__ + "static/media/total-questions.375c638cd2a10427276997576c73cbd1.svg";
export { ForwardRef as ReactComponent };